import { render, staticRenderFns } from "./ShippingInstructionInfo.vue?vue&type=template&id=7f2b86c6&scoped=true&"
import script from "./ShippingInstructionInfo.vue?vue&type=script&lang=js&"
export * from "./ShippingInstructionInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShippingInstructionInfo.vue?vue&type=style&index=0&id=7f2b86c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2b86c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f2b86c6')) {
      api.createRecord('7f2b86c6', component.options)
    } else {
      api.reload('7f2b86c6', component.options)
    }
    module.hot.accept("./ShippingInstructionInfo.vue?vue&type=template&id=7f2b86c6&scoped=true&", function () {
      api.rerender('7f2b86c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/shipping-instruction/ShippingInstructionInfo.vue"
export default component.exports